(function () {
  function showStatus(row, isLowStock) {
    const lowEls = row.querySelectorAll('[data-status="low"]');
    const inEls = row.querySelectorAll('[data-status="in"]');

    lowEls.forEach((el) => (el.style.display = isLowStock ? "" : "none"));
    inEls.forEach((el) => (el.style.display = isLowStock ? "none" : ""));
  }

  const rows = document.querySelectorAll(".status-row[data-product-id]");
  if (!rows.length) return;

  rows.forEach((row) => {
    const productIdRaw = row.getAttribute("data-product-id");
    const productId = parseInt(productIdRaw, 10);

    if (!Number.isFinite(productId)) return;

    // Deterministic 3 out of 5:
    // values 0,1,2 => low stock (3/5)
    // values 3,4 => in stock (2/5)
    const bucket = productId % 5;
    const isLowStock = bucket < 3;

    showStatus(row, isLowStock);
  });
})();
